import { SelectSexQuestion } from "@/pages/quiz/base/questions/selectSex";
import { HeightWeightInputsQuestion } from "@/pages/quiz/base/questions/heightWeightInputs";
import { CustomInputQuestion } from "@/pages/quiz/base/questions/customInput";
import { SingleChoiceQuestion } from "@/pages/quiz/base/questions/singleChoice";
import { MultipleChoiceQuestion } from "@/pages/quiz/base/questions/multipleChoice";
import { DoctorPrescribeBanner } from "@/pages/quiz/base/questions/banners/doctorsPrescribeBanner";
import { ProgressCalculationBanner } from "@/pages/quiz/base/questions/banners/progressCalculationBanner";
import { DisclaimerAcknowledgmentQuestion } from "@/pages/quiz/base/questions/disclaimerAcknowledgment";
import { CheckoutAddressFields } from "@/pages/quiz/base/questions/contactField/checkoutAddress";
import { ContactFieldsCheckout } from "@/pages/quiz/base/questions/contactField/checkout";
import { ErrorDeadEndBanner } from "@/pages/quiz/base/questions/errorBanner";
import { ContactsFieldsCPL } from "@/pages/quiz/base/questions/contactField/contactFieldsCPL";
import { WelcomeScreen } from "@/pages/quiz/base/questions/welcomeScreen";
import { AttachmentBlock } from "@/pages/quiz/base/questions/attachmentBlock";
import { SumsubAttachmentBlock } from "@/pages/quiz/base/questions/sumsubAttachmentBlock";
import { GoodbyeScreen } from "@/pages/quiz/base/questions/goodbyeScreen";
import { ContactsFieldsCPA } from "@/pages/quiz/base/questions/contactField/contactFieldsCPA";
import { ContactEmailField } from "@/pages/quiz/base/questions/contactField/contactEmailField";
import { ContactFullNameDob } from "@/pages/quiz/base/questions/contactField/contactFullNameDob";
import { ContactForAvailablePlans } from "@/pages/quiz/base/questions/contactField/contactForAvailablePlans";
import { OnlyLicencedPharmaciesBanner } from "@/pages/quiz/base/questions/banners/onlyLicencedPharmaciesBanner";
import { RealUsersRealResultsBanner } from "@/pages/quiz/base/questions/banners/realUsersRealResultsBanner";
import { DoctorHealthHistoryBanner } from "@/pages/quiz/base/questions/banners/doctorHealthHistoryBanner";
import { ApprovedByDoctorQuestion } from "@/pages/quiz/base/questions/banners/approvedDoctorBanner";
import { BenefitsCompareBanner } from "@/pages/quiz/base/questions/banners/benefitsCompareBanner";
import { PhotoInstructionsBanner } from "@/pages/quiz/base/questions/banners/photoInstructionsBanner";
import { BeforeAfterQuestion } from "@/pages/quiz/base/questions/banners/beforeAfterBanner";
import {
  SelectTreatmentOptionBundleNew,
  SelectTreatmentOptionNew,
} from "@/pages/quiz/base/questions/selectTreatmentOptionNew";
import { PreviewSelectTreatmentOption } from "@/pages/quiz/base/questions/selectTreatmentOptionNew/components/LoadingAnimation";
import { ContactDob } from "@/pages/quiz/base/questions/contactDob";
import { DisclaimerAcknowledgmentOneSubmit } from "@/pages/quiz/base/questions/disclaimerAcknowledgmentOneSubmit";
import { heightWeightInputsWithBMI } from "@/pages/quiz/base/questions/heightWeightInputsWithBMI";
import { OurGLPPlans } from "@/pages/quiz/base/questions/ourGlpPlans";
import { SelectState } from "@/pages/quiz/base/questions/selectState";
import { ContactFullName } from "@/pages/quiz/base/questions/contactFullName";
import { WeCanHelpYouLose } from "@/pages/quiz/base/questions/banners/weCanHelpYouLose";
import { ContactForAvailablePlansAddress } from "@/pages/quiz/base/questions/contactField/contactForAvailablePlansAddress";
import { QuestionBlockResult } from "@/pages/quiz/context/types";
import { CustomFormBlock } from "@/types";
import { CalculatingYourPotentialWeightLoss } from "@/pages/quiz/base/questions/calculatingYourPotentialWeightLoss";
import { ChartYourPotentialWeightLoss } from "@/pages/quiz/base/questions/chartYourPotentialWeightLoss";
import { CustomGallbladderDate } from "@/pages/quiz/base/questions/customGallbladderDate";
import { CustomDate } from "@/pages/quiz/base/questions/customDate";
import { MedicationWaiverConsent } from "@/pages/quiz/base/questions/medicationWaiverConsent";
import { CustomNumberInputQuestion } from "@/pages/quiz/base/questions/customNumberInput";
import { MonthlyCheckInSupportQuestion } from "@/pages/quiz/base/questions/monthlyCheckInSupportQuestion";
import { CustomRedirectScreen } from "@/pages/quiz/base/questions/customRedirect";
import { ProductConsentsQuestion } from "@/pages/quiz/base/questions/productConsents";

export const componentMap: {
  [key: string]: QuestionBlockResult;
} = {
  // cover special core questions for mobile app with simple feedback
  "app-highest-weight": {
    Component: CustomNumberInputQuestion,
  },
  "core-highest-weight": {
    Component: CustomNumberInputQuestion,
  },
  "glp-consent": {
    Component: SingleChoiceQuestion,
  },
  "core-glp-consent": {
    Component: SingleChoiceQuestion,
  },
  // Cover check-in case.
  "app-current-weight": {
    Component: CustomNumberInputQuestion,
  },

  "app-weight-goal": {
    Component: CustomNumberInputQuestion,
  },
  "core-weight-goal": {
    Component: CustomNumberInputQuestion,
  },
  /*  */

  "select-sex": {
    Component: SelectSexQuestion,
  },
  "sign-up-advanced": {
    Component: CalculatingYourPotentialWeightLoss,
    config: {
      prerenderMode: false,
      hideProgressBar: true,
      isHideBackButton: () => true,
    },
  },
  "sign-up-advanced-2": {
    Component: ChartYourPotentialWeightLoss,
    config: {
      hideProgressBar: true,
      prerenderMode: false,
      isHideBackButton: () => true,
    },
  },
  "select-state": {
    Component: SelectState,
  },
  "height-weight-input-fields": {
    Component: HeightWeightInputsQuestion,
  },
  "height-weight-input-fields-with-bmi": {
    Component: heightWeightInputsWithBMI,
  },
  "height-weight-input-fields-basic": {
    Component: HeightWeightInputsQuestion,
  },
  "custom-input-field": {
    Component: CustomInputQuestion,
  },

  "custom-email-field": {
    Component: ContactEmailField,
  },
  "custom-full-name-dob": {
    Component: ContactFullNameDob,
  },
  "contact-full-name": {
    Component: ContactFullName,
  },
  "custom-dob": {
    Component: ContactDob,
  },
  "custom-product-consents": {
    Component: ProductConsentsQuestion,
  },
  "medication-waiver-consent": {
    Component: MedicationWaiverConsent,
  },
  "medication-consent-update": {
    Component: MedicationWaiverConsent,
  },
  "custom-gallbladder-date": {
    Component: CustomGallbladderDate,
  },
  "custom-data": {
    Component: CustomDate,
  },
  "custom-contact-for-available-plans": {
    Component: ContactForAvailablePlans,
  },
  "custom-contact-for-available-plans-address": {
    Component: ContactForAvailablePlansAddress,
  },
  "custom-select-treatment-option": {
    Component: SelectTreatmentOptionNew,
    config: {
      prerenderMode: true,
      PreviewComponent: PreviewSelectTreatmentOption,
    },
  },
  "custom-select-treatment-option-bundle": {
    Component: SelectTreatmentOptionBundleNew,
    config: {
      prerenderMode: true,
      PreviewComponent: PreviewSelectTreatmentOption,
    },
  },
  "custom-single-choice": {
    Component: SingleChoiceQuestion,
  },
  "benefits-compare-hero": {
    Component: BenefitsCompareBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "custom-multiple-choice": {
    Component: MultipleChoiceQuestion,
  },
  "custom-multiple-choice-oral-reasons": {
    Component: MultipleChoiceQuestion,
  },
  "progress-calculation": {
    Component: ProgressCalculationBanner,
  },
  "side-effect-acknowledgement-one-submit": {
    Component: DisclaimerAcknowledgmentOneSubmit,
  },
  "side-effect-acknowledgement": {
    Component: DisclaimerAcknowledgmentQuestion,
  },
  // special case for quiz 10_000 which triggers quiz finishing
  "side-effect-acknowledgement-v2": {
    Component: DisclaimerAcknowledgmentQuestion,
  },
  "contacts-fields-checkout": {
    Component: ContactFieldsCheckout,
  },
  "shipping-fields-checkout": {
    Component: CheckoutAddressFields,
  },
  "error-screen": {
    Component: ErrorDeadEndBanner,
  },
  "custom-welcome-screen": {
    Component: WelcomeScreen,
  },
  "sumsub-verification": {
    Component: SumsubAttachmentBlock,
    config: {
      hideProgressBar: true,
    },
  },
  "custom-attachment": {
    Component: AttachmentBlock,
  },

  "full-body-photo-attachment": {
    Component: AttachmentBlock,
  },
  "custom-goodbye-screen": {
    Component: GoodbyeScreen,
    config: {
      hideProgressBar: true,
    },
  },
  "custom-redirect-screen": {
    Component: CustomRedirectScreen,
    config: {
      hideProgressBar: true,
      isHideSubmitButton: true,
    },
  },
  "contacts-fields-cpa": {
    Component: ContactsFieldsCPA,
  },
  "contacts-fields": {
    Component: ContactsFieldsCPL,
    config: {
      hideProgressBar: true,
    },
  },

  // banners
  "approved-banner-hero": {
    Component: ApprovedByDoctorQuestion,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "doctors-prescribe-banner": {
    Component: DoctorPrescribeBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "photo-instructions-banner": {
    Component: PhotoInstructionsBanner,
    config: {
      prerenderMode: true,
    },
  },
  "before-after-carousel": {
    Component: BeforeAfterQuestion,
    config: {
      prerenderMode: true,
    },
  },
  "only-licenced-pharmacies-banner": {
    Component: OnlyLicencedPharmaciesBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "real-users-real-results-banner": {
    Component: RealUsersRealResultsBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "doctor-health-history-banner": {
    Component: DoctorHealthHistoryBanner,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "loose-weight-plot": {
    Component: WeCanHelpYouLose,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "loose-weight-plot-banner": {
    Component: WeCanHelpYouLose,
    config: {
      prerenderMode: true,
      enableAnimation: true,
    },
  },
  "our-glp-plans": {
    Component: OurGLPPlans,
    config: {
      prerenderMode: true,
    },
  },
  "monthly-check-in-support": {
    Component: MonthlyCheckInSupportQuestion,
    config: {
      prerenderMode: true,
    },
  },
};

const emptyResult: QuestionBlockResult = {
  Component: () => null,
  config: {},
};

export const getQuestionBlock = (selectedQuestion: CustomFormBlock | null) =>
  componentMap[selectedQuestion?.name ?? ""] || emptyResult;
